import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ElementRenderer, generateElementKey } from '../ElementRenderer.js';
import { getVariant, propToText, toText } from '../layout.js';
import { cn } from '../lib/utils.js';
export function Metric({ element }) {
    const { content, props, children } = element;
    const variant = getVariant(props);
    // If metric has children, render them (custom layout)
    if (children && children.length > 0) {
        return (_jsx("div", { className: "flex flex-col gap-1", style: {
                width: props.width ? String(props.width) : undefined,
                height: props.height ? String(props.height) : undefined,
            }, children: children.map((child, i) => (_jsx(ElementRenderer, { node: child }, generateElementKey(child, i)))) }));
    }
    // Otherwise, use props-based rendering
    const label = toText(content) || propToText(props.label);
    const value = propToText(props.value);
    const change = propToText(props.change);
    const trend = propToText(props.trend);
    // Determine trend color
    const getTrendColor = () => {
        if (trend === 'up')
            return 'text-success';
        if (trend === 'down')
            return 'text-destructive';
        return 'text-muted-foreground';
    };
    // Determine trend icon
    const getTrendIcon = () => {
        if (trend === 'up')
            return '↑';
        if (trend === 'down')
            return '↓';
        return '';
    };
    return (_jsxs("div", { className: "flex flex-col gap-1", style: {
            width: props.width ? String(props.width) : undefined,
            height: props.height ? String(props.height) : undefined,
        }, children: [label && _jsx("span", { className: "text-sm text-muted-foreground", children: label }), value && (_jsx("span", { className: cn('text-2xl font-semibold', variant === 'success' && 'text-success', variant === 'warning' && 'text-warning', variant === 'danger' && 'text-destructive'), children: value })), change && (_jsxs("span", { className: cn('text-sm flex items-center gap-1', getTrendColor()), children: [getTrendIcon(), change] }))] }));
}
//# sourceMappingURL=Metric.js.map